module.exports = __webpack_public_path__ + "img/joinDialog-tip.ed0b5c24.jpg";